// extracted by mini-css-extract-plugin
module.exports = {"grid":"MyCourcesStyle_grid__3wz9I","card":"MyCourcesStyle_card__3CuVJ","detail":"MyCourcesStyle_detail__643g8"};